import React from "react";
import {Table, Col, Divider} from "antd";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {propductTablePropType} from "./ProductTablePropTypes";
import {paymentTypes} from "../../../constants/constants";

export const ProductDetailContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const ResponsiveTableWrapper = styled.div`
    width: 100%;

    .ant-table-wrapper {
        margin: 0 !important;
    }

    .ant-table {
        margin: 0 !important;
    }

    .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
        margin: 0 !important;
    }

    .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper .ant-table {
        margin: 0 !important;
    }

    @media (max-width: 768px) {
        width: 100%;

        .ant-table-wrapper {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            margin: 0 !important;
        }

        .ant-table {
            font-size: 12px;
            width: 100%;
            margin: 0 !important;
        }

        .ant-table-thead > tr > th {
            padding: 8px 6px;
            font-size: 12px;
            white-space: nowrap;
            background: #fafafa;
        }

        .ant-table-tbody > tr > td {
            padding: 10px 6px;
            font-size: 13px;
            word-break: break-word;
        }
    }
`;

const ResponsiveCol = styled(Col)`
    @media (max-width: 768px) {
        padding: 0 4px !important;
        margin-top: 10px;

        .ant-divider {
            margin: 10px 0 8px 0;
            font-size: 13px;
            font-weight: 600;
        }

        .ant-divider-inner-text {
            padding: 0 6px;
        }

        p {
            margin-left: 4px !important;
            margin-right: 4px !important;
            font-size: 13px;
            word-break: break-word;
            line-height: 1.5;
            color: #333;
            padding: 10px;
            background: #f9f9f9;
            border-radius: 6px;
            border: 1px solid #e8e8e8;
        }

        b {
            color: #1890ff;
            font-size: 14px;
            font-weight: 600;
        }
    }
`;

const ProductTable = (props: propductTablePropType) => {
    const {
        showPaymentInfo = false,
        showNote = true,
        price = "0",
        paymentType = "",
        showBarcode = false,
        barcode = undefined,
        codPaymentBrandLabel = undefined
    } = props;
    const {t} = useTranslation(["paymentTypes"]);
    //#region views
    return (
        <ProductDetailContainer>
            <ResponsiveTableWrapper>
                <Table
                    rowKey="_id"
                    dataSource={props.dataSource}
                    pagination={Boolean(props.pagination)}
                    data-testid="productTable"
                    size="small"
                >
                    <Table.Column
                        dataIndex="productName"
                        title={t("fields.productName", {ns: "common"})}
                        render={text => <span data-testid="productName">{text}</span>}
                    />
                    <Table.Column
                        dataIndex="ingredients"
                        title={t("fields.productContent", {ns: "common"})}
                        render={text => <span data-testid="ingredients">{text}</span>}
                    />
                    <Table.Column
                        dataIndex="amount"
                        title={t("fields.productAmount", {ns: "common"})}
                        render={text => <span data-testid="amount">{text}</span>}
                    />
                </Table>
            </ResponsiveTableWrapper>
            {showNote && (
                <ResponsiveCol span={24}>
                    <Divider orientation="left">{t("fields.orderNote", {ns: "common"})}</Divider>
                    <p
                        data-testid="deliveryNote"
                        style={{
                            marginLeft: 40,
                            marginRight: 40
                        }}
                    >
                        {props.note}
                    </p>
                </ResponsiveCol>
            )}
            {showPaymentInfo && (
                <ResponsiveCol span={24}>
                    <Divider orientation="left">{t("fields.paymentInfo", {ns: "common"})}</Divider>
                    <p
                        data-testid="paymentInfo"
                        style={{
                            marginLeft: 40,
                            marginRight: 40
                        }}
                    >
                        <b>{`${price || "0"}₺ `}</b>(
                        {t(paymentTypes.find(pT => pT.value == paymentType)?.translation_key, {
                            ns: "paymentTypes"
                        }) || t("unknown", {ns: "paymentTypes"})}
                        )
                        {codPaymentBrandLabel && (
                            <b data-testid="codPaymentBrand" style={{display: "block"}}>
                                {codPaymentBrandLabel}
                            </b>
                        )}
                    </p>
                </ResponsiveCol>
            )}
            {showBarcode && barcode && (
                <ResponsiveCol span={24}>
                    <Divider orientation="left">{t("fields.barcode", {ns: "common"})}</Divider>
                    <p
                        data-testid="orderBarcode"
                        style={{
                            marginLeft: 40,
                            marginRight: 40
                        }}
                    >
                        {barcode}
                    </p>
                </ResponsiveCol>
            )}
        </ProductDetailContainer>
    );
    //#endregion
};

export default ProductTable;
